<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <div class="card card-primary">
    <div class="card-header">
      <h5 class="card-title" id="accordion">
        <i class="fa-solid fa-gavel"></i>
        &nbsp; Arremates
      </h5>
    </div>
    <div class="card-body table-responsive p-2">
      <table class="table table-hover" style="position: relative">
        <thead>
          <tr>
            <th style="width: 15px !important">Seq</th>
            <th>DataHora</th>
            <th>Leilão</th>
            <th>Lote</th>
            <th>Praça</th>
            <th>Valor de arremate</th>
            <th>Parcelado</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(arremate, index) in lotes" :key="arremate">
            <td>{{ index + 1 }}</td>

            <td>
              <div>
                {{ formatDateTime(arremate.lote_lance_data) }}
              </div>
            </td>

            <td>
              <div>{{ arremate.leilao_id }} - {{ arremate.leilao_titulo }}</div>
            </td>
            <td>
              <div>{{ arremate.lote_numero }} - {{ arremate.lote_titulo }}</div>
            </td>
            <td>
              <div>
                {{ arremate.lote_lance_praca }}
              </div>
            </td>
            <td>
              <div>R$ {{ toCurrency(arremate.lote_lance) }}</div>
            </td>
            <td>
              <span v-if="arremate.lote_ultimo_lance_parcelado == 1">Sim</span>
              <span v-else>Não</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import currencyController from "../controller/currencyController";

export default {
  props: ["lotes"],

  mixins: [currencyController],

  data() {
    return {
      isLoading: false,
      doc_tipo_usuario_selecionado: "",
      upload_files: "",
      aux_docs_tipo_usuario: [],
    };
  },

  mounted() {},

  methods: {
    formatDateTime(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>
